import { selectors } from './data'

// Queue
export function getActiveQueue(state) {
    return selectors.queue.getActiveQueue(state.toasterReducer)
}

export function getButtonEnabled(state) {
    return selectors.queue.getButtonEnabled(state.toasterReducer)
}

export function getVisible(state) {
    return selectors.queue.getVisible(state.toasterReducer)
}

// Settings
export function getLanguage(state) {
    return selectors.settings.getLanguage(state.toasterReducer)
}

export function getAscending(state) {
    return selectors.settings.getAscending(state.toasterReducer)
}

export function getMaxToShow(state) {
    return selectors.settings.getMaxToShow(state.toasterReducer)
}

export function getTimeoutBarVisibility(state) {
    return selectors.settings.getTimeoutBarVisibility(state.toasterReducer)
}

export function getRequestCountVisibility(state) {
    return selectors.settings.getRequestCountVisibility(state.toasterReducer)
}

// Toasts
export function getToasts(state) {
    return selectors.toasts.getToasts(state.toasterReducer)
}

export function getMotds(state) {
    return selectors.toasts.getMotds(state.toasterReducer)
}



// WEBPACK FOOTER //
// ./src/features/Toaster/selectors.js